import type { ExperimentEligibility, ExperimentGate } from '@/hooks/useFeedExperiment';

/**
 * Steht mit diesem Upload eine Gabel an?
 *
 * `experiment_eligibility` verlangt fuer die Testpopulation
 * `upload_status = 'not_uploaded'`. Ein vollstaendiger Upload nimmt dem Feed
 * damit die Vergleichsgruppe, und ein A/B-Test ist fuer diesen Feed nicht mehr
 * moeglich. Das ist kein Fehler, sondern die logische Folge — aber der Nutzer
 * sollte es vorher wissen und nicht hinterher.
 *
 * Zwei Faelle zaehlen als "waere testbar":
 *  - der Feed erfuellt die Gates JETZT, oder
 *  - er scheitert AUSSCHLIESSLICH an der fehlenden Freigabe (dann macht ihn
 *    genau die Handlung testbar, die gerade laeuft).
 *
 * Bewusst eng: ein Hinweis, der auf jedem Feed steht, wird nach dem zweiten Mal
 * nicht mehr gelesen. Laeuft bereits ein Experiment, steht keine Gabel an — dort
 * regelt der Control-Guard den Upload.
 */
export function isExperimentAtRisk(e: ExperimentEligibility | null | undefined): boolean {
  if (!e) return false;
  if (e.running_experiment_id) return false;
  if (e.eligible) return true;

  // Fallback deckt das Deploy-Fenster ab, in dem das Frontend schon neu ist und
  // die RPC noch nicht (gleiches Muster wie ExperimentCard).
  const gates: ExperimentGate[] = e.failing_gates?.length
    ? e.failing_gates
    : e.failing_gate
      ? [e.failing_gate]
      : [];

  // Die Laengenpruefung ist nicht kosmetisch: `every` auf einer leeren Liste ist
  // true, der Hinweis stuende dann genau dann, wenn wir am wenigsten wissen.
  return gates.length > 0 && gates.every((g) => g === 'approval');
}
